<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header :data-background-color="headerColor">
            <h4 class="title">Extrato Financeiro</h4>
            <p v-if="pendingPayments.length > 0 && isDueMonth" class="category">
              Você possui débitos pendentes
            </p>
            <p v-else class="category">
              Você não possui débitos pendentes esse mês :)
            </p>
          </md-card-header>
          <md-card-content>
            <payment-table :table-header-color="headerColor"></payment-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { PaymentTable } from "@/pages";
import { formatDate } from "@/helpers";

export default {
  components: {
    PaymentTable
  },
  computed: {
    headerColor() {
      return this.pendingPayments.length > 0 && this.isDueMonth
        ? "red"
        : "primary";
    },
    pendingPayments() {
      return this.$store.getters.pendingPayments;
    },
    isDueMonth() {
      if (this.pendingPayments.length === 0) {
        return false;
      }

      const today = new Date();
      const dueDate = new Date(formatDate(this.pendingPayments[0].date));

      return (
        today.getFullYear() >= dueDate.getFullYear() &&
        ((today.getDate() > dueDate.getDate() - 5 &&
          today.getMonth() == dueDate.getMonth()) ||
          today.getMonth() > dueDate.getMonth())
      );
    }
  }
};
</script>

<style scoped>
button {
  margin-left: 15px;
}
.container-buttons {
  display: flex;
  justify-content: space-between;
}
.md-icon {
  font-size: 40px !important;
  margin-right: 15px;
}
</style>
